// src/app/guards/auth.guard.ts
import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectIsAuthenticated } from '../store/auth/auth.selectors';
import { map, take } from 'rxjs/operators';

export const authGuard: CanMatchFn = () => {
  const router = inject(Router);
  const store = inject(Store);
  return store.select(selectIsAuthenticated).pipe(
    take(1),
    map((ok) => (ok ? true : router.createUrlTree(['/login'])))
  );
};

// src/app/guards/guest.guard.ts
export const guestGuard: CanMatchFn = () => {
  const router = inject(Router);
  const store = inject(Store);
  return store.select(selectIsAuthenticated).pipe(
    take(1),
    map((ok) => (ok ? router.createUrlTree(['/home']) : true))
  );
};
